import { useState } from 'react';
import { GPGKey } from '../../types';
import GenerateStageDialog from './GenerateStageDialog';
import SuccessStageDialog from './SuccessStageDialog';

type DialogStage = 'generate' | 'success';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const AddGPGKeyDialog = ({ isOpen, onClose }: Props) => {
  const [dialogStage, setDialogStage] = useState<DialogStage>('generate');
  const [generatedKey, setGeneratedKey] = useState<GPGKey | null>(null);

  const handleClose = () => {
    onClose();
    setDialogStage('generate');
    setGeneratedKey(null);
  };

  return dialogStage === 'generate' ? (
    <GenerateStageDialog
      isOpen={isOpen}
      onClose={handleClose}
      onSuccess={(key: GPGKey) => {
        setGeneratedKey(key);
        setDialogStage('success');
      }}
    />
  ) : (
    <SuccessStageDialog
      isOpen={isOpen}
      onClose={handleClose}
      gpgKey={generatedKey!}
    />
  );
};

export default AddGPGKeyDialog;
